import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const QuestionFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput source="ExamId" reference="Admin/CMSExam" label="所属考试" alwaysOn>
            <SelectInput optionText="Title" />
        </ReferenceInput>
        <SelectInput source="Type" label="题型" choices={[
            { id: 'single', name: '单选题' },
            { id: 'multi', name: '多选题' },
            { id: 'judge', name: '判断题' },
            { id: 'fill', name: '填空题' },
        ]} />
    </Filter>
);

export const QuestionList = props => (
    <List {...props} filters={<QuestionFilter />} title="题目管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ReferenceField source="ExamId" reference="Admin/CMSExam" label="所属考试">
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="Type" label="题型" />
            <TextField source="Content" label="题目内容" />
            <TextField source="Answer" label="正确答案" />
            <TextField source="Score" label="分值" />
            <TextField source="Sort" label="排序" />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const QuestionEdit = props => (
    <Edit {...props} title="编辑题目">
        <SimpleForm>
            <TextInput disabled source="id" />
            <ReferenceInput source="ExamId" reference="Admin/CMSExam" label="所属考试">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <SelectInput source="Type" label="题型" choices={[
                { id: 'single', name: '单选题' },
                { id: 'multi', name: '多选题' },
                { id: 'judge', name: '判断题' },
                { id: 'fill', name: '填空题' },
            ]} />
            <TextInput source="Content" label="题目内容" multiline fullWidth />
            <TextInput source="Options" label="选项(JSON格式)" multiline fullWidth helperText='例如: ["选项A", "选项B", "选项C", "选项D"]' />
            <TextInput source="Answer" label="正确答案" helperText="单选/判断填字母或true/false，多选用逗号分隔如A,B,C" />
            <TextInput source="Analysis" label="答案解析" multiline fullWidth />
            <NumberInput source="Score" label="分值" />
            <NumberInput source="Sort" label="排序" />
        </SimpleForm>
    </Edit>
);

export const QuestionCreate = props => (
    <Create {...props} title="新建题目">
        <SimpleForm>
            <ReferenceInput source="ExamId" reference="Admin/CMSExam" label="所属考试">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <SelectInput source="Type" label="题型" defaultValue="single" choices={[
                { id: 'single', name: '单选题' },
                { id: 'multi', name: '多选题' },
                { id: 'judge', name: '判断题' },
                { id: 'fill', name: '填空题' },
            ]} />
            <TextInput source="Content" label="题目内容" multiline fullWidth />
            <TextInput source="Options" label="选项(JSON格式)" multiline fullWidth helperText='例如: ["选项A", "选项B", "选项C", "选项D"]' />
            <TextInput source="Answer" label="正确答案" helperText="单选/判断填字母或true/false，多选用逗号分隔如A,B,C" />
            <TextInput source="Analysis" label="答案解析" multiline fullWidth />
            <NumberInput source="Score" label="分值" defaultValue={5} />
            <NumberInput source="Sort" label="排序" defaultValue={0} />
        </SimpleForm>
    </Create>
);
